import ProfileAvatar from "./ProfileAvatar";
import { IonIcon } from "@ionic/react";
import { chevronDown } from "ionicons/icons";
import { User } from "../types/user.type";
import QuoQuestCrownImg from "../assets/graphics/crown.png";
import LevelsModal from "./LevelsModal";
import { useState } from "react";

const ProfileHeader = ({ profile }: { profile: User }) => {
  const [isLevelModuleOpen, setIsLevelModuleOpen] = useState(false);
  const handleOpenModal = () => {
    setIsLevelModuleOpen(true);
  };

  const handleCloseModal = () => {
    setIsLevelModuleOpen(false);
  };

  return (
    <>
      <div className="flex flex-row justify-between">
        <ProfileAvatar imgUrl={profile.img} />
        <div className="flex flex-col justify-center items-left grow">
          <div className="text-white text-xl">{`${profile?.firstName} ${profile?.lastName}`}</div>
          <div className="text-xs bg-primary-70 rounded w-fit px-2 py-1 text-[#fbff0a]">
            {profile?.username}
          </div>
        </div>
        <div
          className="bg-[#fbff0a] rounded shadow flex items-center justify-center text-xl font-bold text-black m-2 px-2 cursor-pointer"
          onClick={() => handleOpenModal()}
        >
          <img
            src={QuoQuestCrownImg}
            alt="Quest Level Crown"
            className="mr-2 max-h-8"
          />
          {profile?.level ?? 1}
          <IonIcon className="p-1" icon={chevronDown} />
        </div>
      </div>
      <LevelsModal
        modalIsOpen={isLevelModuleOpen}
        modalIsDismissed={handleCloseModal}
      />
    </>
  );
};
export default ProfileHeader;
